export const AUTH_KEYS = {
  CONTAINER: "authenticated-app-container",
  HEADER: "authenticated-app-header",
  BODY: "authenticated-app-body",
};
